import { retrieveSecrets } from "../apis/secrets";
import { SECRET_FIELDS } from "../constants/secretFields";

/**
 * Generic function to get one secret by ID and field
 * @param {string} applicantId - The applicant ID
 * @param {string} field - The secret field to retrieve
 * @returns {Promise<string>} The decrypted secret value
 */
export const getOneSecretById = async (applicantId, field) => {
  try {
    /**
     * @type {Array<{field: string, value: string}>}>}
     */
    const secrets = await retrieveSecrets(applicantId, [field]);
    return secrets[0].value;
  } catch (error) {
    console.error(`Failed to retrieve secret ${field}:`, error);
    throw error;
  }
};

/**
 * Get submission password for an applicant
 * @param {string} applicantId - The applicant ID
 * @returns {Promise<string>} The decrypted submission password
 */
export const getSecretSubmissionPassword = async (applicantId) => {
  return getOneSecretById(applicantId, SECRET_FIELDS.SUBMISSION_PASSWORD);
};

/**
 * Get submission email password for an applicant
 * @param {string} applicantId - The applicant ID
 * @returns {Promise<string>} The decrypted submission email password
 */
export const getSecretEmailSubmissionPassword = async (applicantId) => {
  return getOneSecretById(applicantId, SECRET_FIELDS.SUBMISSION_EMAIL_PASSWORD);
};

